import {useEffect} from 'react';

import {useGetStyleHook} from '../../generated/src/GetStyle/get.hook';
import {darken, lighten} from '@mui/material/styles';

export const THEME_DARKEN_COEFFICIENT = 0.15;
export const THEME_LIGHTEN_COEFFICIENT = 0.1;
export const THEME_HOVER_ALPHA = 0.05;

const initializeTheme = () => {
    const {data: styleData} = useGetStyleHook();

    useEffect(() => {
        if (styleData?.data) {
            var primaryColor = styleData.data['--sdb-theme-primary'];
            var contrastText = styleData.data['--tcg-primary-color-onprimary'];

            const primaryLight = lighten(primaryColor, THEME_LIGHTEN_COEFFICIENT);

            const primaryDark = darken(primaryColor, THEME_DARKEN_COEFFICIENT);

            document.body.style.setProperty('--mui-palette-primary-light', primaryLight);
            document.body.style.setProperty('--mui-palette-primary-main', primaryColor);
            document.body.style.setProperty('--mui-palette-primary-dark', primaryDark);
            document.body.style.setProperty('--mui-palette-primary-contrastText', contrastText);
        }
    }, [styleData]);
};

export default initializeTheme;
